export default "__VITE_ASSET__VUKLhtUg__"